import { ThemeService } from '@/app/core/services/theme/theme.service';
import {Component, computed, EventEmitter, inject, Output} from '@angular/core';

@Component({
  selector: 'app-modal-pasos-campana',
  standalone: true,
  imports: [],
  templateUrl: './modal-pasos-campana.html',
  styleUrl: './modal-pasos-campana.scss'
})
export class ModalPasosCampana {
  private themeService = inject(ThemeService);

  protected themeContent = this.themeService.themeContent;
  protected modalPasosCampanaContent = computed(() => this.themeContent()?.shared.campaignStepsModal);

  @Output() cerrar = new EventEmitter<void>();
  onClose() {
    this.cerrar.emit();
  }

}
